import type {Schedule} from '../types/domain'
import {createContext} from 'react'

import schedule1 from '../blindsupervision-ed_2023-10-21-export.json'

export const ScheduleContext = createContext<{schedules: Schedule[]; updateSchedules: () => Promise<void>}>({
  schedules: [schedule1],
  updateSchedules: async () => {},
})
